export type FourByFourChoice = '' | '4x4' | 'non_4x4';

export const FOUR_BY_FOUR_OPTIONS: { value: FourByFourChoice; label: string }[] = [
    { value: '', label: 'Either' },
    { value: '4x4', label: '4x4 only' },
    { value: 'non_4x4', label: 'Non-4x4 only' },
];

export const NON_4X4_HINT = 'Also matches vehicles whose drive type is unknown.';

export const toRequires4x4 = (choice: FourByFourChoice | undefined): boolean | null => {
    if (choice === '4x4') return true;
    if (choice === 'non_4x4') return false;
    return null;
};

export const fromRequires4x4 = (value: boolean | null | undefined): FourByFourChoice => {
    if (value === true) return '4x4';
    if (value === false) return 'non_4x4';
    return '';
};
